export default {
	OrganizationTransferInvoice(state) {
		return state.OrganizationTransferInvoice;
	},
	OrganizationTransferInvoices(state) {
		return state.OrganizationTransferInvoices;
	},
	SuppliersOrganization(state) {
		if (
			state.OrganizationTransferInvoice &&
			state.OrganizationTransferInvoice.Suppliers &&
			state.OrganizationTransferInvoice.Suppliers.length > 0
		) {
			return state.OrganizationTransferInvoice.Suppliers;
		}
		return null;
	},
	Total(state) {
		return state.Total;
	},
	IsLoadingData(state) {
		return state.IsLoadingData;
	}
};
